import React, { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
//import getUrlParam from 'Utils/UrlParamsModule';
import './DayPreviewModal.css';

let moment = require('moment');

class DayPreviewModal extends Component {

    closeModal = () => {
        this.props.handleClose();
    }

    cancelModal = () => {
        this.closeModal();
        this.props.onCancel && this.props.onCancel();
    }

    acceptModal = () => {
        this.closeModal();
        this.props.onAccept && this.props.onAccept();
    }

    getStationsList = () => {
        //checks
        if (this.props.stationData === undefined || this.props.stationData === null) return null;
        if (this.props.stationData.length === 0) return null;

        //create a counter that checks for the next available day to load
        let checkDate = this.props.date;
        while (this.props.stationData[checkDate.format('D')] === undefined) {
            checkDate.add('days', 1);
        }

        //get list of data
        let date_number = Number(this.props.date.format('D'));
        // console.log("date_number", date_number);
        let station_list = this.props.stationData[date_number];
        // console.log("station_data", this.props.stationData);
        // console.log("station_list", station_list);

        //seperate list in today's dates and the next session's dates
        let selected_day_list = station_list.filter(station => Number(moment(station.time).format('D')) === date_number);
        let next_day_list =
            station_list
                .filter(station => Number(moment(station.time).format('D')) !== date_number)
                .filter(station => station.display_day_before);

        // console.log("Selected day list: ", selected_day_list);
        // console.log("Next day list: ", next_day_list);

        let next_day_items = this.getNextDayList(next_day_list);

        //convert it to ul element
        //if they select the same day, must consider greying out passed timeslots
        if (this.props.date.isSame(moment(), 'day')) {
            return (
                <div>
                    <ul className="station_list" > {
                        selected_day_list.map(station =>
                            <li key={station.timeslot_id}>
                                <div className={this.isTimePassed(station) ? 'slot-passed' : 'timeslot-container'} onClick={() => this.redirectToCrowdCtrl(station)}>
                                    <div className="time-label" >
                                        {moment(station.time).format('hh:mm a')}
                                    </div>
                                    <div
                                        className={"quantity-label " + this.isTimePassed(station) ? 'pass-text' : ''} >
                                        {
                                            this.isTimePassed(station)
                                                ? "PASSED"
                                                : <span className={this.getQuantityColour(station.available_quantity, station.offered_quantity)}>
                                                    {station.available_quantity + " left"}
                                                </span>
                                        }
                                    </div>
                                </div >
                            </li>
                        )} </ul>
                    {next_day_items}
                </div>
            )
        } else {
            return (
                <div>
                    <ul className="station_list" > {
                        selected_day_list.map(station =>
                            <li key={station.timeslot_id}>
                                < div className='timeslot-container' onClick={() => this.redirectToCrowdCtrl(station)}>
                                    <div className="time-label" >
                                        {moment(station.time).format('hh:mm a')}
                                    </div>
                                    <div
                                        className="quantity-label" >
                                        {
                                            <span className={this.getQuantityColour(station.available_quantity, station.offered_quantity)} >
                                                {station.available_quantity + " left"}
                                            </span>
                                        }
                                    </div>
                                </div >
                            </li>
                        )} </ul>
                    {next_day_items}
                </div>
            )
        }
    }

    getNextDayList = (list) => {
        if (list === null || list === undefined) return null;
        if (list.length === 0) return null;

        let next_date = moment(list[0].time);

        return (
            <div>
                <div className="next-day-title">{next_date.format('dddd, MMMM Do')}</div>
                <ul className="next-day-list">
                    {list.map(station =>
                        <li key={station.timeslot_id}>
                            <div className='timeslot-container' onClick={() => this.redirectToCrowdCtrl(station)}>
                                <div className="time-label" >
                                    {moment(station.time).format('hh:mm a')}
                                </div>
                                <div
                                    className="quantity-label" >
                                    {
                                        <span className={this.getQuantityColour(station.available_quantity, station.offered_quantity)} >
                                            {station.available_quantity + " left"}
                                        </span>
                                    }
                                </div>
                            </div>
                        </li>
                    )}
                </ul>
            </div>

        )
    }

    redirectToCrowdCtrl = (station) => {
        // console.log("I GOT A CLICK!");
        // console.log("STATION SELECTED: ", station);
        let date = moment(station.time).startOf('day').toDate()
        // console.log("the date: ", date);

        //create a local storage item to be sent with redirect
        let booking_info = {
            // timeslot_id: station.timeslot_id,
            time: date,
            location_id: this.props.locationID,
            location_name: this.props.locationName
        }

        // console.log("BOOKING INFO: ", booking_info);

        localStorage.setItem('bookingData', JSON.stringify(booking_info));

        let getUrl = window.top.location;
        let baseUrl = getUrl.protocol + "//" + getUrl.host;
        console.log("GETURL",getUrl);

        let url = `${baseUrl}/booking/location`;

        // let url = "https://www.ctrlv.ca/booking/location";
        window.top.location.href = url;

    }

    isTimePassed = (station) => {
        //if station is BEFORE present (ie passed)
        if (moment(station.time).isBefore(moment())) return true;
        return false;
    }

    getQuantityColour = (quantity_taken, spots) => {
        let percent_filled = (spots - quantity_taken) / spots * 100;

        if (percent_filled === 100) {
            return "slot-full";
        } else if (percent_filled >= 75) {
            return "slot-almost-full"
        } else {
            return "slot-empty"
        }
    }

    getModalContent = () => {

        // console.log("MODAL PROPS: ", this.props);
        let date = this.props.date.format('dddd, MMMM Do');

        let stationList = this.getStationsList();
        // console.log('stationLIST: ', stationList);

        return (<div className={'Modal'} >
            <div className={'Modal-shield'}
                onClick={this.cancelModal} > {}
            </div>
            <div className={'Modal-content'} >
                <div className={'Modal-title'} >
                    {date} { /*this is where I need to display the date*/}
                </div>
                <div className={'Modal-body'} >
                    <Scrollbars style={
                        { height: 300 }
                    } > {stationList}
                    </Scrollbars >
                    { /*this is where I need to insert the scrollable list of times*/}
                </div>
                <div className={'Modal-continue'} onClick={this.acceptModal} >
                    Go Back
                    </div>
            </div >
        </div>
        );
    }

    render() {

        // console.log("Modal propS: ", this.props);

        let modalContent = this.getModalContent();
        if (this.props.isOpen) {
            return modalContent;
        } else {
            return null;
        }
    }
}

export default DayPreviewModal;
